import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { authApi } from '../../api/auth';
import { GQLArgs } from '../../types';

type UpdatePasswordResponse = { updatePassword: { message: string } };

export const useMutationResetPassword = (args?: GQLArgs<UpdatePasswordResponse>) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<UpdatePasswordResponse | undefined>();

  const mutation = useCallback(
    async ({ variables }: { variables: { newPassword: string; resetToken: string } }) => {
      setLoading(true);
      try {
        await authApi.updatePassword(
          variables.resetToken,
          variables.newPassword,
          variables.newPassword,
        );
        const shaped: UpdatePasswordResponse = { updatePassword: { message: 'ok' } };
        setData(shaped);
        args?.onCompleted?.(shaped);
        toast.success('Password updated successfully', { autoClose: 5000 });
        return shaped;
      } catch (err: any) {
        args?.onError?.(err);
      } finally {
        setLoading(false);
      }
    },
    [args],
  );

  return { mutation, data, loading, error: undefined };
};
